/* eslint-env browser */

export default function () {
  return {
    url: document.referrer
  };
}